// @flow
import React from 'react';
import _ from 'lodash';
import moment from 'moment';
import Print from 'rc-print';
import logoEn from '../../../images/logo/noon_en.svg';
import logoAr from '../../../images/logo/noon_ar.svg';
import I18n from '../../../i18n/I18n';
import Helper from '../../../helper/Helper';

const PrintInvoice = props => {
    const {
        setRef,
        lang,
        printAsn,
        asn,
        seller,
        unidentifiedAsn,
        businessType,
        selectedTab,
        barcodeRecvMethod,
    } = props;

    let { transfersType } = props;

    if (businessType !== 2 && asn && asn.asn_type) {
        transfersType = asn.asn_type === 'fromnoon' ? 2 : 1;
    }

    const otherStyle = `
    @import url('https://fonts.googleapis.com/css?family=Cairo:200,400,700&subset=arabic,latin-ext');


             .printTable {
               width: 100%;
               font-family: ${
                   lang === 'ar' ? 'Cairo' : 'Proxima Nova'
               }, sans-serif;
               border-collapse: collapse;
               color: #404553;
               text-align: ${lang === 'ar' ? 'right' : 'left'};
               font-size: 12px;
               direction: ${lang === 'ar' ? 'rtl' : 'ltr'};

             }
             .tableHead {
               position: relative;
               font-size: 12px;
               background: #eeeeee;
               -webkit-print-color-adjust:exact;
             }
             .printTable td, .printTable th {
               padding: 10px;
               border-bottom: 1px solid #ebedee;
               direction: ${lang === 'ar' ? 'rtl' : 'ltr'};
             }
             .printTable tr {
               direction: ${lang === 'ar' ? 'rtl' : 'ltr'};

             }
             .noWrap {
               white-space: nowrap;
             }


               .bold {
                 font-weight: 600;
               }



               /***/

               .ctr {
                 font-family: ${
                     lang === 'ar' ? 'Cairo' : 'Proxima Nova'
                 }, sans-serif;

                 color: #404553;
                 background: yellow;
                 padding: 10px 0;
                 direction: ${lang === 'ar' ? 'rtl' : 'ltr'};
               }
               .header {
                 display: flex;
                 align-items: center;
                 justify-content: center;
                 background: red;
                 direction: ${lang === 'ar' ? 'rtl' : 'ltr'};
                 border-bottom: 1px solid #eaeaea;
                 padding: 10px 0 20px;
               }
               .logoCtr {
                 height: 35px;

               }
               .logo {
                 height: 100%;
                 width: auto;
               }

               .summary {
                 border-bottom: 1px solid #eaeaea;
                 padding: 10px 0;
                 display: flex;
                 align-items: flex-start;
                 justify-content: space-between;
                 direction: ${lang === 'ar' ? 'rtl' : 'ltr'};
               }


               .asnCtr {
                 margin-left: ${lang === 'ar' ? 0 : '20px'};
                 margin-right: ${lang === 'ar' ? '20px' : 0};
                 direction: ${lang === 'ar' ? 'rtl' : 'ltr'};
                 flex: 1;
               }

               .asnCtr:first-child {
                 margin-left: 0;
                 margin-right: 0;
               }

               .asnTitle {
                 color: #bababa;
                 font-size: 11px;
                 font-family: ${
                     lang === 'ar' ? 'Cairo' : 'Proxima Nova'
                 }, sans-serif;
                 direction: ${lang === 'ar' ? 'rtl' : 'ltr'};
               }
               .asnNr {
                 color: #4a4a4a;
                 font-size: 15px;
                 font-weight: 600;
                 font-family: ${
                     lang === 'ar' ? 'Cairo' : 'Proxima Nova'
                 }, sans-serif;
                 margin: 5px 0;
               }
               .priority {
                  text-align: center;
                  width: 100%;
                  text-transform: uppercase;
                  font-size: 20px;
                  font-weight: 600;
                  font-family: ${
                      lang === 'ar' ? 'Cairo' : 'Proxima Nova'
                  }, sans-serif;
               }
               .tableTitle {
                 color: #4a4a4a;
                 -webkit-print-color-adjust:exact;
                 font-size: 20px;
                 text-transform: capitalize;
                 text-decoration: underline;
                 font-weight: 600;
                 line-height: 1.4;
                 padding: 10px 0;
                 direction: ${lang === 'ar' ? 'rtl' : 'ltr'};
                 font-family: ${
                     lang === 'ar' ? 'Cairo' : 'Proxima Nova'
                 }, sans-serif;
                 margin: 5px 0;
               }
               .eachTable {
                 margin: 10px 0 40px;
               }
               .flexFix {
                 flex: 1;
               }
               .center {
                 text-align: center;
               }
               .attributes {
                 font-size: 12px;
                 color: #93939a;
                 font-weight: unset;
                 direction: ${lang === 'ar' ? 'rtl' : 'ltr'};

               }
               .eachAttr {
                 margin-right: ${lang === 'ar' ? '0' : '10px'};
                 margin-right: ${lang === 'en' ? '10px' : '0'};
                 // white-space: nowrap;
                 direction: ${lang === 'ar' ? 'rtl' : 'ltr'};

               }

               a {
                 color: #404553;
                 font-weight: 600;
                 direction: ${lang === 'ar' ? 'rtl' : 'ltr'};

               }

       `;

    const productBox = item => (
        <div>
            {item.title}
            <div className="attributes">
                <span className="eachAttr bold">
                    <a>{item.brand}</a>
                </span>
                <span>
                    {item.variant ? (
                        <span className="eachAttr">
                            {I18n.getHtml('order-details.variant', {
                                variant: item.variant,
                            })}
                        </span>
                    ) : (
                        ''
                    )}
                </span>
                <span>
                    {item.model ? (
                        <span className="eachAttr">
                            {I18n.getHtml('order-details.model', {
                                model: item.model,
                            })}
                        </span>
                    ) : (
                        ''
                    )}
                </span>
                {item.attributes && !_.isEmpty(JSON.parse(item.attributes)) ? (
                    <span className="eachAttr">
                        {JSON.parse(item.attributes).colour_family ? (
                            <span>
                                {I18n.getHtml('order-details.color', {
                                    color: JSON.parse(item.attributes)
                                        .colour_family,
                                })}
                            </span>
                        ) : (
                            ''
                        )}
                    </span>
                ) : (
                    ''
                )}
            </div>
        </div>
    );

    const eachTab = (title, list, property) => (
        <div className="eachTable">
            {selectedTab ||
            (title && title !== 'null' && title !== 'undefined') ? (
                <h3 className="tableTitle">{selectedTab || title}</h3>
            ) : (
                ''
            )}
            <table className="printTable">
                <thead>
                    <tr className="tableHead">
                        {property.haveVal('item_nr') ? (
                            <th>{I18n.getText('order-details.item-nr')}</th>
                        ) : (
                            ''
                        )}
                        {property.haveVal('ref_nr') ? (
                            <th>{I18n.getText('transfers.ref-nr')}</th>
                        ) : (
                            ''
                        )}
                        {property.haveVal('title') ? (
                            <th>{I18n.getText('product-table.name')}</th>
                        ) : (
                            ''
                        )}
                        {property.haveVal('partner_sku') ? (
                            <th>{I18n.getText('product-table.p-sku')}</th>
                        ) : (
                            ''
                        )}
                        {property.haveVal('partner_barcode') &&
                        barcodeRecvMethod ? (
                            <th>{I18n.getText('transfers.partner-barcode')}</th>
                        ) : (
                            ''
                        )}
                        {property.haveVal('sku') ? (
                            <th>{I18n.getText('product-table.sku')}</th>
                        ) : (
                            ''
                        )}
                        {property.haveVal('status') ? (
                            <th>{I18n.getText('product-table.status')}</th>
                        ) : (
                            ''
                        )}
                        {property.haveVal('reject_reason') ? (
                            <th>{I18n.getText('transfers.rejected-reason')}</th>
                        ) : (
                            ''
                        )}
                        {property.haveQtyVal('qty') ? (
                            <th>{I18n.getText('variants.qty')}</th>
                        ) : (
                            ''
                        )}
                        {property.haveVal('slot') ? (
                            <th>{I18n.getText('transfers.time-slot')}</th>
                        ) : (
                            ''
                        )}
                        {property.haveQtyVal('qty_expected') ? (
                            <th>{I18n.getText('transfers.expected')}</th>
                        ) : (
                            ''
                        )}
                        {property.haveQtyVal('qty_received') ? (
                            <th>{I18n.getText('transfers.received')}</th>
                        ) : (
                            ''
                        )}
                        {property.haveQtyVal('qty_rejected') ? (
                            <th>{I18n.getText('transfers.rejected')}</th>
                        ) : (
                            ''
                        )}
                        {property.haveQtyVal('qty_qc_rejected') ? (
                            <th>{I18n.getText('transfers.qc-rejected')}</th>
                        ) : (
                            ''
                        )}
                        {property.haveVal('return_asn') ? (
                            <th>{I18n.getText('transfers.return-asn')}</th>
                        ) : (
                            ''
                        )}
                        {property.haveVal('parent_asn') ? (
                            <th>{I18n.getText('transfers.parent-asn')}</th>
                        ) : (
                            ''
                        )}
                    </tr>
                </thead>
                <tbody>{list}</tbody>
            </table>
        </div>
    );

    const la = (data, property) => {
        const divStyle = {
            fontWeight: '600',
        };

        return data && !_.isEmpty(data)
            ? data.map((item, index) => {
                  let itemNrs = [];
                  const splitBarcode =
                      item &&
                      item.partner_barcode &&
                      item.partner_barcode.split(',');
                  const barCodes = (
                      <div>
                          {splitBarcode
                              ? splitBarcode.map(barcode => {
                                    return (
                                        <div style={divStyle}>
                                            {barcode || ''}
                                        </div>
                                    );
                                })
                              : '-'}
                      </div>
                  );

                  if (item.item_nr) {
                      itemNrs = item.item_nr.split(',');
                  }

                  const itemNrList =
                      itemNrs && !_.isEmpty(itemNrs)
                          ? itemNrs.map((singleItemNr, index) => (
                                <div>{singleItemNr}</div>
                            ))
                          : '';

                  return (
                      <tr>
                          {property.haveVal('item_nr') ? (
                              <td className="noWrap bold">{itemNrList}</td>
                          ) : (
                              ''
                          )}
                          {property.haveVal('ref_nr') ? (
                              <td className="noWrap bold">{item.ref_nr}</td>
                          ) : (
                              ''
                          )}
                          {property.haveVal('title') ? (
                              <td>{productBox(item)}</td>
                          ) : (
                              ''
                          )}
                          {property.haveVal('partner_sku') ? (
                              <td className="noWrap">{item.partner_sku}</td>
                          ) : (
                              ''
                          )}

                          {property.haveVal('partner_barcode') ? (
                              <td className="noWrap">{barCodes || '-'}</td>
                          ) : (
                              ''
                          )}
                          {property.haveVal('sku') ? (
                              <td className="noWrap">{item.sku || '-'}</td>
                          ) : (
                              ''
                          )}

                          {property.haveVal('status') ? (
                              <td className="noWrap">{item.status}</td>
                          ) : (
                              ''
                          )}
                          {property.haveVal('reject_reason') ? (
                              <td className="noWrap">{item.reject_reason}</td>
                          ) : (
                              ''
                          )}
                          {property.haveQtyVal('qty') ? (
                              <td className="noWrap">{item.qty}</td>
                          ) : (
                              ''
                          )}
                          {property.haveVal('slot') ? (
                              <td className="noWrap">{item.slot}</td>
                          ) : (
                              ''
                          )}
                          {property.haveQtyVal('qty_expected') ? (
                              <td className="noWrap">{item.qty_expected}</td>
                          ) : (
                              ''
                          )}
                          {property.haveQtyVal('qty_received') ? (
                              <td className="noWrap">{item.qty_received}</td>
                          ) : (
                              ''
                          )}
                          {property.haveQtyVal('qty_rejected') ? (
                              <td className="noWrap">{item.qty_rejected}</td>
                          ) : (
                              ''
                          )}
                          {property.haveQtyVal('qty_qc_rejected') ? (
                              <td className="noWrap">{item.qty_qc_rejected}</td>
                          ) : (
                              ''
                          )}
                          {property.haveVal('return_asn') ? (
                              <td className="noWrap">
                                  {item.return_asn || '-'}
                              </td>
                          ) : (
                              ''
                          )}
                          {property.haveVal('parent_asn') ? (
                              <td className="noWrap">{item.parent_asn}</td>
                          ) : (
                              ''
                          )}
                      </tr>
                  );
              })
            : '';
    };

    let grouped = {};

    if (businessType !== 2) {
        grouped =
            asn && asn.items ? _.mapValues(_.groupBy(asn.items, 'status')) : '';
    } else if (asn && asn.transfer_info && asn.lines) {
        grouped[asn.transfer_info.status] = asn.lines;
    }

    const keys = [];

    if (grouped) {
        for (let x in grouped) {
            keys.push(x);
        }
    }

    let d = [];

    for (let a = 0; a < keys.length; a++) {
        const data = grouped[keys[a]];

        const property = Helper.validator(data);

        if (data && !_.isEmpty(data)) {
            if (
                !unidentifiedAsn ||
                (unidentifiedAsn &&
                    unidentifiedAsn.items &&
                    _.isEmpty(unidentifiedAsn.items)) ||
                (unidentifiedAsn &&
                    unidentifiedAsn.items &&
                    !_.isEmpty(unidentifiedAsn.items) &&
                    !_.isEqual(data.sort(), unidentifiedAsn.items.sort()))
            ) {
                d.push(eachTab(keys[a], la(data, property), property));
            }
        }
    }

    if (
        unidentifiedAsn &&
        unidentifiedAsn.items &&
        !_.isEmpty(unidentifiedAsn.items)
    ) {
        const property = Helper.validator(unidentifiedAsn.items);

        d.push(
            eachTab(
                I18n.getText('transfers.unidentified'),
                la(unidentifiedAsn.items, property),
                property,
            ),
        );
    }

    const slotList =
        asn &&
        asn.transfer_info &&
        asn.transfer_info.slot &&
        !_.isEmpty(asn.transfer_info.slot)
            ? asn.transfer_info.slot.map((eachSlot, index) => (
                  <span>
                      {eachSlot}
                      {index + 1 < asn.transfer_info.slot.length ? ', ' : ''}
                  </span>
              ))
            : '';

    return (
        <div>
            <Print
                ref={setRef}
                insertHead={false}
                ignoreHeadJs={false}
                title={lang === 'ar' ? 'عمليات النقل' : 'Transfers'}
                otherStyle={otherStyle}
            >
                <div style={{ display: 'none' }} className="ctr">
                    <div className="header">
                        <div className="logoCtr">
                            <img
                                src={lang === 'ar' ? logoAr : logoEn}
                                alt="logo"
                                className="logo"
                            />
                        </div>
                    </div>
                    <div className="summary">
                        {transfersType === 2 &&
                        asn &&
                        asn.rtv &&
                        asn.rtv.zone_code ? (
                            <div className="asnCtr">
                                <h4 className="asnTitle">
                                    {I18n.getText(
                                        'statement-details.finance-view-statement-type',
                                    )}
                                </h4>
                                <div className="asnNr">{asn.rtv.zone_code}</div>
                            </div>
                        ) : (
                            ''
                        )}
                        {asn && asn.asn && asn.asn.received_at ? (
                            <div className="asnCtr">
                                <h4 className="asnTitle">
                                    {I18n.getText('transfers.received-at')}
                                </h4>
                                {
                                    <div className="asnNr">
                                        {moment(asn.asn.received_at).format(
                                            `YYYY-MM-DD [${
                                                lang === 'ar' ? '' : 'at'
                                            }] h:mm:ss a`,
                                        )}
                                    </div>
                                }
                            </div>
                        ) : (
                            ''
                        )}
                        {asn && asn.rtv && asn.rtv.shipped_at ? (
                            <div className="asnCtr">
                                <h4 className="asnTitle">
                                    {I18n.getText('transfers.shipped-at')}
                                </h4>
                                {
                                    <div className="asnNr">
                                        {moment(asn.rtv.shipped_at).format(
                                            `YYYY-MM-DD [${
                                                lang === 'ar' ? '' : 'at'
                                            }] h:mm:ss a`,
                                        )}
                                    </div>
                                }
                            </div>
                        ) : (
                            ''
                        )}
                        {seller ? (
                            <div className="asnCtr">
                                <h4 className="asnTitle">
                                    {I18n.getText('print.partner-name')}
                                </h4>
                                <div className="asnNr">{seller.storeName}</div>
                            </div>
                        ) : (
                            ''
                        )}
                        {barcodeRecvMethod ? (
                            <div className="asnCtr">
                                <h4 className="asnTitle">
                                    {I18n.getText('transfers.recv-type')}
                                </h4>
                                <div className="asnNr">
                                    {I18n.getText('transfers.barcode')}
                                </div>
                            </div>
                        ) : (
                            ''
                        )}
                        {businessType !== 2 ? (
                            <div className="asnCtr">
                                <h4 className="asnTitle">
                                    {I18n.getText('transfers.direction')}
                                </h4>
                                <div className="asnNr">
                                    {I18n.getText(
                                        transfersType === 2
                                            ? 'transfers.from-noon'
                                            : 'transfers.to-noon',
                                    )}
                                </div>
                            </div>
                        ) : (
                            ''
                        )}
                        {businessType === 2 &&
                        asn &&
                        asn.transfer_info &&
                        asn.transfer_info.warehouse_from ? (
                            <div className="asnCtr">
                                <h4 className="asnTitle">
                                    {I18n.getText('transfers.from-wh')}
                                </h4>
                                <div className="asnNr">
                                    {asn.transfer_info.warehouse_from}
                                </div>
                            </div>
                        ) : (
                            ''
                        )}
                        {businessType === 2 &&
                        asn &&
                        asn.transfer_info &&
                        asn.transfer_info.warehouse_to ? (
                            <div className="asnCtr">
                                <h4 className="asnTitle">
                                    {I18n.getText('transfers.to-wh')}
                                </h4>
                                <div className="asnNr">
                                    {asn.transfer_info.warehouse_to}
                                </div>
                            </div>
                        ) : (
                            ''
                        )}
                        {businessType === 2 &&
                        asn &&
                        asn.transfer_info &&
                        asn.transfer_info.scheduled_at ? (
                            <div className="asnCtr">
                                <h4 className="asnTitle">
                                    {I18n.getText('transfers.scheduled-at')}
                                </h4>
                                <div className="asnNr">
                                    {asn.transfer_info.scheduled_at}
                                </div>
                                <div className="asnNr">{slotList}</div>
                            </div>
                        ) : (
                            ''
                        )}
                        <div className="asnCtr">
                            <h4 className="asnTitle">
                                {I18n.getText(
                                    transfersType === 2
                                        ? 'transfers.rtv-nr'
                                        : 'transfers.asn',
                                )}
                            </h4>
                            <div className="asnNr">{printAsn}</div>
                        </div>
                    </div>
                    <div className="summary">
                        {(transfersType === 1 && asn && asn.asn) ||
                        (transfersType === 2 && asn && asn.rtv) ? (
                            <div className="asnCtr">
                                <h4 className="asnTitle">
                                    {I18n.getText('transfers.from-wh')}
                                </h4>
                                <div className="asnNr">
                                    {transfersType === 1
                                        ? asn.asn.from_address
                                        : asn.rtv.from_address}
                                </div>
                            </div>
                        ) : (
                            ''
                        )}
                        {(transfersType === 1 && asn && asn.asn) ||
                        (transfersType === 2 && asn && asn.rtv) ? (
                            <div className="asnCtr">
                                <h4 className="asnTitle">
                                    {I18n.getText('transfers.to-wh')}
                                </h4>
                                <div className="asnNr">
                                    {transfersType === 1
                                        ? asn.asn.to_address
                                        : asn.rtv.to_address}
                                </div>
                            </div>
                        ) : (
                            ''
                        )}
                        {seller &&
                            seller.is_fbn_asn_priority &&
                            asn &&
                            asn.transfer_info &&
                            asn.transfer_info.scheduled_at && (
                                <div className="priority">
                                    {I18n.getText('transfers.priority')}
                                </div>
                            )}
                    </div>
                    <div className="tableCtr">{d && d.length > 0 ? d : ''}</div>
                </div>
            </Print>
        </div>
    );
};

export default PrintInvoice;



// WEBPACK FOOTER //
// ./src/components/transfers/print/Print.js